import React, {useState} from 'react'
import { Button } from 'reactstrap';
export default function UploadShipmentFile() {
     // select file input (shipmentUploadedFile)
     const [input, setInput] = useState('')
     const [uploadedFileUrl, setUploadedFileUrl] = useState();
 
 
     const handleUploadFile = async () => {
         const formData = new FormData();
 
         formData.append('File', input);
 
         const response = await fetch(
             '/api/Files/Upload/customsDocument',
             {
                 method: 'POST',
                 body: formData,
             }
         )
         const data = await response.text()
         console.log(data)
         setUploadedFileUrl(data)
         if (response.ok) {
             setInput('')
         }
         if (!response.ok) {
             alert(`${data} upload was NOT successful, if you want to try again please reselect your file`)
             setInput('')
         }
     };
  return (
    <div>
          <div className='d-flex justify-content-between mr-5'>
                    <div style={{ visibility: 'visible' }}>
                        <label className='mr-1'>Shipment file: </label>
                        <input type="file" id="shipmentUploadedFile" name="filename"
                            onChange={(e) => { setInput(e.target.files[0]); }}
                        ></input>
                        {input &&
                            <Button
                                color="success"
                                onClick={handleUploadFile}
                            >Upload</Button>
                        }
                    </div>
                    {
                        <input className="btn btn-success" type="submit" value='Fertig' disabled={input}
                        // onClick={() => { postSendReceiveShipment() }} 
                        />
                    }
                </div>
    </div>
  )
}
